import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import './tooltip.css';

const CustomTooltip = ({children, title, placement = null, light = null, ...rest}) => {
    const needsWrapper = typeof title === 'string' ||
        (React.isValidElement(title) && title.type === React.Fragment);
    const normalizedTitle = needsWrapper
        ? <p className="p-1 text-light" style={{ margin: 0 }}>{title}</p>
        : title;
    return(
        <OverlayTrigger
            key={rest.key}
            placement={placement == null ? 'top' : placement}
            delay={{ show: 250, hide: 400 }}
            overlay={
                <Tooltip id="custom-tooltip" className={`custom-tooltip ${light != null ? 'lightBackground' : ''}`}>
                    {normalizedTitle}
                </Tooltip>
            }
            {...rest}
            >
            {children}
        </OverlayTrigger>
    );
}
export default CustomTooltip;